import { createTheme, responsiveFontSizes } from '@material-ui/core/styles';

function createMUITheme({ primary = '#006eba', secondary = '#008A00', template = 'A' } = {}) {
  const theme = createTheme({
    palette: {
      type: 'light',
      primary: {
        main: primary,
        contrastText: '#ffffff',
      },
      secondary: {
        main: secondary,
        contrastText: '#ffffff',
      },
    },
    typography: {
      htmlFontSize: 14,
      fontFamily: `"${template === 'B' ? 'Inter' : 'Montserrat'}" , "Roboto", "Helvetica","Arial"`,
      h1: {
        fontSize: '2.5rem',
      },
      h2: {
        fontSize: '2rem',
      },
      h3: {
        fontSize: '1.8rem',
      },
      h4: {
        fontSize: '1.7rem',
      },
      h5: {
        fontSize: '1.6rem',
      },
      h6: {
        fontSize: '1.5rem',
      },
      subtitle1: {
        fontSize: '1.07rem',
      },
      subtitle2: {
        fontSize: '0.95rem',
      },
      body1: {
        fontSize: '1.07rem',
      },
      body2: {
        fontSize: '0.95rem',
      },
    },
  });

  theme.overrides = {
    MuiCssBaseline: {
      '@global': {
        '@font-face': {
          fontFamily: 'Montserrat',
          fontStyle: 'normal',
          fontWeight: 400,
          fontDisplay: 'swap',
          src: `url('https://cdn.smartbr.com/isp/assets/fonts/montserrat/montserrat-v14-latin-regular.woff')`,
        },
      },
    },
    MuiAlert: {
      root: {
        alignItems: 'center',
      },
      message: {
        fontWeight: 'bold',
      },
    },

    MuiFormHelperText: {
      contained: {
        marginLeft: '0',
        marginRight: '0',
        marginTop: '0',
        marginBottom: '0',
        padding: '0 3px',
      },
      error: {
        fontSizer: '12px',
        lineHeight: '15px',
      },
    },
  };

  return responsiveFontSizes(theme);
}

export default createMUITheme;
